import React from "react";
import { Helmet } from "react-helmet";

import { LANGS, DEFAULT_LANG, SITE, langPrefix } from "../../languages";

// Canonical URL and links to the same page in every language, for pages whose path is the same
// in each language (articles build their own, since their slugs are translated).
const PageLinks = ({ lang, path }) => (
  <Helmet>
    <link rel="canonical" href={SITE + langPrefix(lang) + path} />
    {LANGS.map((code) => (
      <link key={code} rel="alternate" hrefLang={code} href={SITE + langPrefix(code) + path} />
    ))}
    <link rel="alternate" hrefLang="x-default" href={SITE + langPrefix(DEFAULT_LANG) + path} />
  </Helmet>
);

export default PageLinks;
